module.exports = __webpack_public_path__ + "static/media/iconLeafBlower.bc23e663.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconLeafBlower.svg
// module id = 898
// module chunks = 0